import { Parser } from '~/api';
import { Server } from '~/api/models/Server';
import RequestService from './request';

interface UpdateStartupRequest {
    startup: string;
    egg_id: number;
    docker_image: string;
    skip_scripts: boolean;
    environment: Record<string, string>;
}

class ServerStartupService {
    getAll(): Promise<ListResponse> {
        return RequestService.get('/servers/:server/startup').then(Parser.parse);
    }

    update(data: UpdateStartupRequest): Promise<Server> {
        return RequestService.put('/servers/:server/startup?include=egg', data).then(Parser.parse).then(RequestService.updateModelBinding);
    }
}

export default new ServerStartupService();
